import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceARDebitNoteActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Invoice/InvoiceBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceARDebitNote"
				RenderedComponent={this.RenderedComponent}
				context="FinanceARDebitNote"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceARDebitNoteActivity)
